import React from 'react';
import { AlertContent } from 'components';

interface PaymentMethodRemoveProps {
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

const PaymentMethodRemove = ({ isLoading, onClose, onConfirm }: PaymentMethodRemoveProps) => {
  const handleRemove = () => {
    onConfirm();
  };

  return (
    <AlertContent
      title="Remove payment method?"
      message="Are you sure you want to remove this payment method? You will need to add another payment method to receive payments from your employer."
      leftActionLabel="Cancel"
      onLeftAction={onClose}
      rightActionLabel="Remove"
      onRightAction={handleRemove}
      isLoading={isLoading}
    />
  );
};

export default PaymentMethodRemove;
